import { render, staticRenderFns } from "./diapositiva-10.vue?vue&type=template&id=18554189&scoped=true&"
var script = {}
import style0 from "./diapositiva-10.vue?vue&type=style&index=0&id=18554189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18554189",
  null
  
)

export default component.exports